import { render, staticRenderFns } from "./e-billing.vue?vue&type=template&id=be647360&"
import script from "./e-billing.vue?vue&type=script&lang=ts&"
export * from "./e-billing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports